import _ from 'lodash';
import React, { ReactNode, ReactElement, useMemo } from 'react';
import {
  Menu,
  MenuButtonProps,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SplitButton,
} from '@fluentui/react-components';

import { useEmptyStateSizeContext } from '../contexts/size';
import { getButtonSize } from '../utils/size-utils';

interface EmptyStateSplitButtonProps {
  className?: string;
  children: ReactNode;
  icon?: ReactElement;
  appearance?: 'primary' | 'secondary';
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  secondaryActions: { [key: string]: React.MouseEventHandler<HTMLDivElement> };
}

export const EmptyStateSplitButton = ({
  className,
  children,
  appearance = 'primary',
  icon,
  onClick,
  secondaryActions,
}: EmptyStateSplitButtonProps) => {
  const { size } = useEmptyStateSizeContext();
  const buttonSize = useMemo(() => getButtonSize(size), [size]);

  return (
    <Menu positioning="below-end">
      <MenuTrigger disableButtonEnhancement>
        {(triggerProps: MenuButtonProps) => (
          <SplitButton
            className={className}
            appearance={appearance}
            icon={icon}
            menuButton={triggerProps}
            primaryActionButton={{
              className,
              onClick,
              size: buttonSize,
            }}
          >
            {children}
          </SplitButton>
        )}
      </MenuTrigger>

      <MenuPopover>
        <MenuList className="empty-state-menu-list">
          {_.map(_.keys(secondaryActions), (menuItemKey) => (
            <MenuItem key={menuItemKey} onClick={secondaryActions[menuItemKey]}>
              {menuItemKey}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
